<template>
  <div class="d-flex align-items-center goal-skeleton">
    <div class="avatar rounded-circle shine"></div>
    <div class="title shine col-8"></div>
  </div>
</template>

<script>
/**
 * This is skeleton loader for Goal
 */
export default {
  name: 'Goal'
}
</script>

<style lang="scss" scoped>
.goal-skeleton {
  height: 61px;
}
.avatar {
  height: 26px;
  width: 26px;
  margin-right: 12px;
}
.title {
  height: 26px;
  border-radius: 10px;
}
</style>
